import React, { useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Paper from "@material-ui/core/Paper";
import { AuthSchema, AuthValidation } from "./config/AuthForm";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import TextFormField from "components/Form/TextFormField";
import Logo from "assets/logo/tuvil.svg";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { AuthManager } from "service/AuthManager";
import { ROUTE_PAGE } from "config/RoutePage";
import { useSnackbar } from "notistack";

export default function Auth(props: any) {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(AuthValidation) });
  const { enqueueSnackbar } = useSnackbar();

  const [schemaLogin, setSchemaLogin] = useState(AuthSchema);

  const ViewForm = (schema: any) => {
    return Object.keys(schema).map((key: string, index: any) => {
      return (
        <Grid item xs={12} key={key + index}>
          <TextFormField
            name={key}
            control={control}
            errors={errors}
            {...schema[key]}
            InputProps={
              key === "password"
                ? {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() =>
                            setSchemaLogin((prev) => ({
                              ...prev,
                              password: {
                                ...prev.password,
                                type:
                                  prev.password.type === "password"
                                    ? "text"
                                    : "password",
                              },
                            }))
                          }
                        >
                          {schema[key].type === "password" ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }
                : {}
            }
          />
        </Grid>
      );
    });
  };

  const auth = (data: any) => {
    AuthManager.Login(data.usuario, data.password, () => {
      window.location.replace(ROUTE_PAGE.HOME.VER);
    }).catch((e) =>
      enqueueSnackbar("Verifique su usuario o contraseña", { variant: "error" })
    );
  };

  useEffect(()=>{
    if(AuthManager.isLogin()){
      window.location.replace(ROUTE_PAGE.HOME.VER);
    }
  },[]);

  return (
    <Box
      width="100vw"
      display="flex"
      height="100vh"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={11} sm={6} md={4}>
          <Box m={2}>
            <Paper elevation={2}>
              <Box p={3}>
                <div style={{ textAlign: "center" }}>
                  <img width={120} height={80} src={Logo} alt="Logo Tuvi" />
                </div>

                <form onSubmit={handleSubmit(auth)}>
                  <Grid container spacing={2}>
                    {ViewForm(schemaLogin)}
                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        type="submit"
                        color="primary"
                        variant="contained"
                      >
                        Ingresar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Paper>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
